import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import PageSection from '../../components/PageSection';

const styles = theme => ({
  root: {
    padding: 20
  },
  intro: {
    marginTop: 30,
    marginBottom: 30,
    padding: 30,
    textAlign: 'center',
  },
  introTitle: {
    color: theme.palette.primary.main,
    fontSize: 48,
    fontWeight: 'bold',
    marginBottom: 30
  },
  font: {
    fontSize: 19,
    color: theme.palette.grey.main
  }
});

const shows = [
  {
    id: 1,
    title: 'Yearly Shows',
    description: 'Performance in a formal setting is an exciting opportunity for students to showcase their hard work and improvement over the year in the presence of their family and friends. Shows are held during the fall and are held at various venues in Broward and Dade County.',
    image: 'https://musicology-studio.s3.amazonaws.com/Show_Performance.jpg',
  },
  {
    id: 2,
    title: 'Holiday Concerts',
    description: 'Throughout the year, activities are organized to serve as community outreach projects, which include local performances at nursing homes and other community events.',
    image: 'https://musicology-studio.s3.amazonaws.com/Holiday_Concert.jpg',
  }
];


class Shows extends Component {

  render() {
    const { classes } = this.props;
    return (

      <div className={classes.root}>
        {shows.map(s => <PageSection key={s.id} section={s} plain fullWidth divider circular /> )}
      </div>
    )
  }
}

export default withStyles(styles)(Shows);
